import React from 'react';
import UserProfile from '@components/domain/UserProfile';
import styled from '@emotion/styled';
import { PostList } from '@domain';
import { Button, Text } from '@atomic';
import { CreatePostApi } from '@api/PostApi';
import { useUserContext } from '@contexts/UserContext/UserProvider';
import { COLOR_FONT_GRAY } from '@assets/color';

const ProfileWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
`;

const UserPostsWrapper = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const saveCreatePost = async (values) => {
  const newPostFormData = new FormData();
  newPostFormData.append('image', values.image);
  newPostFormData.append('title', values.title);
  newPostFormData.append('channelId', values.channelId);

  try {
    await CreatePostApi(newPostFormData);

    handleClose();
  } catch (e) {
    console.log('포스트 생성에 실패했습니다.', e);
  }
};

const Profile = () => {
  const { currentUser } = useUserContext();
  const { posts } = currentUser;

  return (
    <ProfileWrapper>
      <UserProfile userInfo={currentUser} />
      <UserPostsWrapper>
        <PostList postList={posts} />
        {posts.length === 0 && (
          <Text
            textColor={COLOR_FONT_GRAY}
            textSize={18}
            style={{ fontStyle: 'italic' }}
          >
            게시글이 존재하지 않습니다.
          </Text>
        )}
        {posts.length > 9 && <Button>load more</Button>}
      </UserPostsWrapper>
    </ProfileWrapper>
  );
};

Profile.propTypes = {};

export default Profile;
